var decodeDynamicsPayload = function (data) {
    var array = [];
    data.forEach((v, k) => {
        array[v.key] = v.value;
    })
    return array;
} ;

document.addEventListener("d365mkt-afterformload", function() {
    console.log("d365mkt-afterformload", 'generic');
    document.querySelectorAll('input[name="alt_utmsorgente"]').forEach((v, k) => {
        v.value = cookie_utm_source;
    });
    document.querySelectorAll('input[name="alt_utmcampagna"]').forEach((v, k) => {
        v.value = cookie_utm_campaign;
    });
    document.querySelectorAll('input[name="alt_venue"]').forEach((v, k) => {
        v.parentNode.classList.add('!relative');
    });
    document.querySelectorAll('input[name="parentaccountid"]').forEach((v, k) => {
        v.parentNode.classList.add('!relative');
    });
    document.querySelectorAll('input[name="alt_interest"]').forEach((v, k) => {
        v.parentNode.classList.add('!relative');
    });
    document.querySelectorAll('input[name="alt_sesso"][value="3"]').forEach((v, k) => {
        v.parentNode.classList.add('!hidden');
    });
});

// var _form_serialize = function (form) {
//     if (!form || form.nodeName !== "FORM") {
//         return;
//     }
//     var i,
//         j,
//         q = [];
//     for (i = 0; i < form.elements.length; i++) {
//         if (form.elements[i].name === "") {
//             continue;
//         }
//         switch (form.elements[i].nodeName) {
//             case "INPUT":
//                 switch (form.elements[i].type) {
//                     case "tel":
//                     case "text":
//                     case "number":
//                     case "date":
//                     case "time":
//                     case "hidden":
//                     case "password":
//                     case "button":
//                     case "reset":
//                     case "submit":
//                         q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
//                         break;
//                     case "checkbox":
//                     case "radio":
//                         if (form.elements[i].checked) {
//                             q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
//                         }
//                         break;
//                     case "file":
//                         break;
//                 }
//                 break;
//             case "TEXTAREA":
//                 q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
//                 break;
//             case "SELECT":
//                 switch (form.elements[i].type) {
//                     case "select-one":
//                         q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
//                         break;
//                     case "select-multiple":
//                         for (j = 0; j < form.elements[i].options.length; j++) {
//                             if (form.elements[i].options[j].selected) {
//                                 q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].options[j].value));
//                             }
//                         }
//                         break;
//                 }
//                 break;
//             case "BUTTON":
//                 switch (form.elements[i].type) {
//                     case "reset":
//                     case "submit":
//                     case "button":
//                         q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
//                         break;
//                 }
//                 break;
//         }
//     }
//     return q.join("&");
// };
//
// window._show_thank_you = function(id, message, trackcmp_url, email) {
//     var form = document.getElementById('_form_' + id + '_'), thank_you = form.querySelector('._form-thank-you');
//     form.querySelector('._form-content').style.display = 'none';
//     thank_you.innerHTML = message;
//     thank_you.style.display = 'block';
//     const vgoAlias = typeof visitorGlobalObjectAlias === 'undefined' ? 'vgo' : visitorGlobalObjectAlias;
//     var visitorObject = window[vgoAlias];
//     if (email && typeof visitorObject !== 'undefined') {
//         visitorObject('setEmail', email);
//         visitorObject('update');
//     } else if (typeof(trackcmp_url) != 'undefined' && trackcmp_url) {
//         // Site tracking URL to use after inline form submission.
//         _load_script(trackcmp_url);
//     }
//     if (typeof window._form_callback !== 'undefined') window._form_callback(id);
//     var event_id = uniqueId('pixel');
//     dataLayer.push({event_id: event_id, event: 'generate_lead'});
//     // var now = Math.floor(Date.now() / 1000);
//     // pixel_trackAPIConversion('CompleteRegistration', event_id, getCookie('_fbp'), getCookie('_fbc'), now);
//     setTimeout(function () {
//         bookAppointment();
//     }, 500);
// };
// window._show_error = function(id, message, html) {
//     var form = document.getElementById('_form_' + id + '_'),
//         err = document.createElement('div'),
//         button = form.querySelector('button'),
//         old_error = form.querySelector('._form_error');
//     if (old_error) old_error.parentNode.removeChild(old_error);
//     err.innerHTML = message;
//     err.className = '_error-inner _form_error _no_arrow';
//     var wrapper = document.createElement('div');
//     wrapper.className = '_form-inner';
//     wrapper.appendChild(err);
//     button.parentNode.insertBefore(wrapper, button);
//     var submitButton = form.querySelector('[id^="_form"][id$="_submit"]');
//     submitButton.disabled = false;
//     submitButton.classList.remove('processing');
//     if (html) {
//         var div = document.createElement('div');
//         div.className = '_error-html';
//         div.innerHTML = html;
//         err.appendChild(div);
//     }
// };